import es from 'date-fns/locale/es';
import React, { Component } from 'react';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  validateAlumnoSeleccionado
} from '../../services/inscripciones/inscripcionesDto';

registerLocale('es', es)

export class ValidarInscripcionCursadas extends Component {
  static displayName = ValidarInscripcionCursadas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      showLookupAnios: false,
      showCursada: false,
      tagDataAlumno: [{ id: "", text: "" }],
      tagDataCursada: [{ id: "", text: "" }],
      alumno: { codigo: "", descripcion: "" },
      cursada: { codigo: "", descripcion: "" },
      startDate: new Date(),
      endDate: new Date(),
      startInscriptionDate: new Date(),
      endInscriptionDate: new Date(),
      carreraCursada: -1,
      materiaCodigo: ""
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleDescripcionChangeInput = this.handleDescripcionChangeInput.bind(this);
    this.handleLlamadoChangeInput = this.handleLlamadoChangeInput.bind(this);
    this.handleShowAniosLookup = this.handleShowAniosLookup.bind(this);
    this.handleSelectAnioItem = this.handleSelectAnioItem.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleShowCursadaLookup = this.handleShowCursadaLookup.bind(this);
    this.handleSelectCursadaItem = this.handleSelectCursadaItem.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleHideLookup1 = this.handleHideLookup1.bind(this);
  }

  handleConfirmButton = () => {
    var isOkToSave = this.isOkToSave();

    if (!isOkToSave) {
      this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });
    } else {
      this.saveStudent();
    }
  }

  async componentDidMount() {
    await constantClass.canAccess('WWInscripcionCursada');
  }

  handleChange = (e) => {
    this.setState({ llamado: e.value });
  }

  handleDelete = (i) => {
    this.setState({ tagDataAlumno: this.state.tagDataAlumno.filter(tag => tag.id !== i), carreraCursada: -1 });
  }

  handleDeleteCursada = (i) => {
    this.setState({ tagDataCursada: this.state.tagDataCursada.filter(tag => tag.id !== i) });
  }

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  }

  handleShowCursadaLookup = () => {
    this.setState({ showCursada: true });
  }

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  }
  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  }

  handleDescripcionChangeInput = e => {
    this.setState({ descripcion: e.target.value });
  }

  handleLlamadoChangeInput = e => {
    this.setState({ llamado: e.target.value });
  }

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      carreraCursada: Number(carreraProperties[3]),
      alumno: {
        codigo: carreraProperties[2],
        descripcion: carreraProperties[0] + " - " + carreraProperties[1]
      }
    });
  }

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showCursada: false,
      materiaCodigo: carreraProperties[5],
      cursada: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1].trim() + " - " + carreraProperties[2].trim() + " - " + carreraProperties[4].trim()
      }
    });
  }

  render() {
    const { loading } = this.state;
    const alumnoDisplay = this.state.alumno.descripcion.trim();

    return (
      <div className="md-page md-validar-inscripcion-cursada">
        <Link className="md-page__back-link" to="/md-ic">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Validar Inscripciones</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione un alumno para validar todas sus inscripciones a cursada pendientes.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Validando inscripciones, espere...</div>
          ) : null}
          {this.state.success && !loading ? (
            <div className="md-page__success">Validaciones realizadas exitosamente</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccionar alumno
                </button>
              ) : null}
              <div className="md-page__field-readonly">{alumnoDisplay}</div>
            </div>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Validar Inscripciones
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupAlumnos selectStudent={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return validateAlumnoSeleccionado(this.state.alumno);
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await inscripcionesService.changeStatusAllInscripcionesCursada(this.state.alumno.codigo);
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        errorMessage: outcome.message
      });
    }
  }
}
